import boatRoutes from './boatRoutes'
import userRoutes from './userRoutes'
import dealerRoutes from './dealerRoutes'
import deviceRoutes from './deviceRoutes'
import engineRoutes from './engineRoutes'
import engineCalibrationFileRoutes from './engineCalibrationRoutes'
import boatModelRoutes from './boatModelRoutes'
import manufacturerRoutes from './manufacturers'
import engineModelRoutes from './engineModelRoutes'
import firebaseRoutes from './firebaseRoutes'
import partRoutes from './partRoutes'
import signalRoutes from './signalRoutes'
import measurementRoutes from './unitOfMeasurementRoutes'
import signalEventManagerRoutes from './signalEventManagerRoutes'
import signalListRoute from './universalSignalListRoutes'
import tagRoutes from './tagRoutes'
import manufacturerDTCRoutes from './manufacturerDTCRoutes'
import userRegistrationRoutes from './userRegistrationRoute'
import dealerProfileRoutes from './dealerProfileRoutes'
export {
    getSupportTickets,
    editSupportTicket,
    deactivateSupportTickets,
} from './supportRoutes'

export const {
    getBoats,
    getProvisionalBoats,
    addBoat,
    editBoat,
    deleteBoat,
    deactivateBoats,
    getUnpairedDeviceBoats,
    getBoatsWithLimiter,
    getUserAssignedBoats,
} = boatRoutes
export const {
    getDealers,
    addDealer,
    activateDealers,
    deleteDealers,
    getDealerQuery,
    getDealersWithLimiter,
    getDealerById,
    getDealerProfile,
} = dealerRoutes

export const {
    getDealerProfiles,
    addDealerProfile,
    getDealerProfilesWithLimiter,
} = dealerProfileRoutes

export const {
    getDevices,
    deactivateDevices,
    addDevice,
    deleteDevice,
    addMultipleDevices,
    getDeviceQuery,
    getDevicesWithLimiter,
} = deviceRoutes
export const {
    getUsers,
    activateUsers,
    getUser,
    editUser,
    addUser,
    getBoatUsers,
    deleteUsers,
    getUsersWithLimiter,
    getUserQuery,
    getUsersByManufacturer,
    getUsersByDealer,
    setNotificationsRead,
} = userRoutes

export const {
    getUserRegistration,
    userRegistrationDeactivation,
    getUsersRegistrationWithLimiter,
    addGuestToRegistration,
    getRegistrationById,
} = userRegistrationRoutes

export {
    getUserProfiles,
    editUserProfile,
    activateUserProfiles,
} from './userProfileRoutes'
export const {
    getEngines,
    addEngine,
    deleteEngines,
    deactivateEngines,
    addCalibrationFile,
    deleteBlobCalibration,
    addEngineImage,
} = engineRoutes
export const {
    getEngineCalibrationFiles,
    addEngineCalibrationFile,
    archiveEngineCalibrationFiles,
    editEngineCalibrationFiles,
    deleteEngineCalibration,
    deactivateEngineCalibrationFiles,
} = engineCalibrationFileRoutes
export const {
    getBoatModels,
    addBoatModel,
    editBoatModels,
    deleteBoatModel,
    deactivateBoatModels,
    cloneBoatModels,
    getBoatModelQuery,
} = boatModelRoutes

export const {
    getManufacturers,
    addManufacturer,
    deleteManufacturer,
    deactivateManufacturers,
    getManufacturerPartnerships,
    setManufacturerPartnership,
    deleteManufacturerPartnership,
} = manufacturerRoutes

export const {
    getManufacturerDTC,
    addManufacturerDTC,
    addSingularManufacturerDTC,
} = manufacturerDTCRoutes

export const {
    getEngineModels,
    addEngineModel,
    deleteEngineModel,
    deactivateEngineModels,
} = engineModelRoutes

export const { createUser, editUserPassword } = firebaseRoutes

export const { getParts } = partRoutes

export const {
    addSignal,
    getSignals,
    editSignal,
    activateSignals,
    deleteSignals,
} = signalRoutes

export const {
    addMeasurement,
    getMeasurement,
    editMeasurement,
    deleteMeasurements,
    deactivateMeasurements,
} = measurementRoutes

export const {
    getEvents,
    addEvent,
    deleteSignalEvent,
    deactivateSignalEvents,
} = signalEventManagerRoutes

export const { getSignalList } = signalListRoute
export { getAuthentication } from './authenticationRoutes'
export { getSignalOrder, postSignalOrder } from './signalOrderRoutes'
export {
    getUserNotificationSubscriptions,
    editUserNotificationSubscriptions,
    dealerNotificationSubscriptions,
    getManufacturerNotificationSubscriptions,
} from './userNotificationSubscriptionsRoutes'
export {
    getSignalProfiles,
    postSignalProfile,
    activateSignalProfiles,
    deleteSignalProfiles,
    cloneSignalProfiles,
} from './signalProfileManagerRoutes'

export {
    getSignalFormulas,
    postSignalFormula,
    activateSignalFormulas,
    deleteSignalFormulas,
} from './signalFormulaRoutes'

export {
    getSubscriptionProfiles,
    postSubscriptionProfile,
    activateSubscriptionProfiles,
    getSubscriptionBoats,
    assignBoatSubscriptions,
    removeBoatSubscriptions,
    getBoatSubscriptionHistory,
} from './subscriptionRoutes'

export const { getTags, addTag, unlinkTag } = tagRoutes

/// Developer routes
export {
    getPatchNotes,
    getMobilePatchNotes,
    addPatchNote,
    addMobilePatchNote,
    deactivatePatchNote,
    deletePatchNote,
    getLatestPatchNotes,
} from './patchNotes'

/// Monitor Routes

export { pingAPI, pingMongo, pingSocket } from './systemMonitorRoutes'

/// Longterm Telemetry Routes

export {
    getTelemetry,
    getBoatTelemetry,
    getBoatVitals,
    getBoatDTCs,
    getBoatAlarms,
    getBoatStatus,
    getAvailableVariables,
    getTripsForBoat,
    getTripGPSData,
    getTripTelemetryData,
    getEngineVariables,
} from './telemetryRoutes'

export { getHistogramData, getAllHistogramData } from './histogramRoutes'

export { getCDNURLS } from './cdnURLRoutes'
